// @flow
import React from 'react';

import { PRODUCT_PRICE_TICKET_CUSTOM } from 'Client/cms/toolkit/constants';
import { ProductPriceTicketCustom } from 'Components/lines/product-price-ticket-custom/ProductPriceTicketCustom';
import { productPriceTicketCustomResolver } from './productPriceTicketCustom.resolver';

export const productPriceTicketCustomDescriptor = {
  name: PRODUCT_PRICE_TICKET_CUSTOM,
  component: ProductPriceTicketCustom,
  resolve: productPriceTicketCustomResolver.resolve,
};
